import PresentUsers from '../PresentUsers/PresentUsers.tsx';
import SensorReadings from '../SensorReadings/SensorReadings.tsx';

const InitLabDashboard = () => {
    return (<>
        <PresentUsers />
        <SensorReadings />
    </>);
};

export default InitLabDashboard;
